<template>
  <div class="">
    <Card class="">
      <template #title> Kullanıcılar</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="this._KullanıcıModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="KullanicilarListesi"
          v-on:set-child-data="getDataChild" />
      </template>
    </Card>

    <Dialog v-model:visible="KullanıcıModal" header="Kullanıcı" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '50vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-6">
          <label for="spanKullanıcıAd" class=" block">Kullanıcı Adı</label>
          <InputText id="spanKullanıcıAd" type="text" v-model="KullaniciAd" class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6"> </div>
        <div class="field col md:col-6">
          <label for="SpanAd" class="block">Ad</label>
          <InputText id="SpanAd" type="text" v-model="Ad" class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="spanSoyad" class="block">Soyad</label>
          <InputText id="spanSoyad" type="text" v-model="Soyad" class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-6">
          <label for="spanRol" class="block">Rol</label>
          <Select id="spanRol" v-model="SelectedRol" :options="RolListesi" optionLabel="Ad" optionValue="Rol_rowid"
            placeholder="Seçiniz..." filter checkmark :highlightOnSelect="true" class="w-full md:w-56" />
        </div>
        <div class="field col md:col-6">

        </div>
        <div class="field col md:col-6">
          <label for="spanSifre" class="block">Şifre</label>
          <Password id="spanSifre" v-model="Sifre" :feedback="false" toggleMask />
        </div>
      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._KullanıcıModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "../../DataTable/DataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      DataTable_render: true,
      KullanicilarListesi: [],
      RolListesi: [],
      KullanıcıModal: false,
      KullanıcıPopUpDurumu: { type: Boolean, value: null }, // True = Yeni Kullanici, False = Edit Kullanıcı
      columns: [
        { field: "KullaniciAd", header: "Kullanıcı Adi" },
        { field: "OlusturmaTarih", header: "Oluşturma Tarihi" },
      ],
      KullaniciAd: null,
      Ad: null,
      Soyad: null,
      SelectedRol: null,
      Sifre: null,
      Kullanici_rowid: null,
      SelectedSirket: null,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.KullanıcıPopUpDurumu = false;
      this.KullanıcıModal = !this.KullanıcıModal;
      this.Kullanici_rowid = getdata_child.data.Kullanici_rowid;
      let data = {
        Kullanici_rowid: getdata_child.data.Kullanici_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetKullaniciInfo", data).then(
        (res) => {
          if (res.status == 200) {
            this.KullaniciAd = res.data[0].KullaniciAd;
            this.Ad = res.data[0].Ad;
            this.Soyad = res.data[0].Soyad;
            this.SelectedRol = res.data[0].pRol;
            this.SelectedSirket = res.data[0].pSirket;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        }
      );
    },
    handleClick() {
      let data = {
        Kullanici_rowid: this.Kullanici_rowid,
        KullaniciAd: this.KullaniciAd,
        Ad: this.Ad,
        Soyad: this.Soyad,
        pRol: this.SelectedRol,
        // pSirket: this.SelectedSirket,
        Sifre: this.Sifre,
      };
      if (this.KullanıcıPopUpDurumu) {
        // Yeni Kullanıcı
        GlobalServis.GlobalServis("POST", "SetKullanici", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Kullanıcı oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._KullanıcıModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      } else {
        // Edit Kullanıcı
        GlobalServis.GlobalServis("POST", "UpdateKullanici", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Kullanıcı düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._KullanıcıModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });

      }
    },
    _KullanıcıModal() {
      this.KullanıcıPopUpDurumu = true;
      this.KullanıcıModal = !this.KullanıcıModal;
      if (!this.KullanıcıModal) {
        this.resetForm();
      }
    },
    resetForm() {
      // this.v$.$reset;
      (this.KullaniciAd = null),
        (this.Ad = null),
        (this.Soyad = null),
        (this.SelectedRol = null),
        (this.Sifre = null);
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    InitServis() {
      this._GetKullaniciListesi();
      this._GetRolListesi();
    },
    _GetKullaniciListesi() {
      GlobalServis.GlobalServis("GET", "GetKullaniciTablosu", "").then(
        (res) => {
          if (res.status == 200) {
            this.KullanicilarListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        }
      )
    },
    _GetRolListesi() {
      GlobalServis.GlobalServis("GET", "GetRol", "").then((res) => {
        if (res.status == 200) {
          this.RolListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.InitServis();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  components: {
    DataTable,
  }
};
</script>
